import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { fetchBinThunk } from "../../../../../redux/TOThunks/Action";
import { RackSearchWrapper } from "./RackSearch.styled";
import BarcodeScanner from "../../../../../components/BarcodeScanner/BarcodeScanner";
import { Divider, Tabs, message } from "antd";
let selectInputRef = React.createRef();
const customStyles = {
  option: (styles) => ({
    ...styles,
    cursor: "pointer",
  }),
  control: (styles) => ({
    ...styles,
    cursor: "pointer",
    width: "250px",
    "&:hover": {
      border: "1px solid #d1eaff",
    },
  }),
};

export class RackSearch extends Component {
  state = {
    selectedRack: null,
    binOptions: [],
    selectedTab: "1",
    isLoading: false,
    openScanner: false,
    selected: null,
  };
  componentDidUpdate = (prevProps) => {
    if (
      prevProps.clearState !== this.props.clearState &&
      this.props.clearState
    ) {
      this.setState({ selected: null, binOptions: [] });
    }
  };
  handleChange = (e, isScan = 0) => {
    this.setState({ selected: e });

    let values = [];

    if (isScan === 1) {
      values.push({
        value: e,
        label: e,
      });
    } else {
      values.push(e);
    }

    localStorage.setItem("selectedBin", values[0]?.label);
    this.props.updateSelectedBin(values[0]);

    this.setState({
      selectedRack: values[0],
      optionData: [],
    });
  };

  onChangeHandler = (e, isScan = false) => {
    if (e?.trim()?.length > 3) {
      this.setState({
        isLoading: true,
      });
      this.props
        .fetchBinThunk({
          access_token: this.props.access_token,
          binNumber: e,
          isPicking: this.props.isPick ?? false,
          isRacking: !this.props.isPick,
          isPutAway: this.props.isPutAway ?? false,
          isScan: isScan,
        })
        .then(() => {
          this.setState({
            isLoading: false,
          });
          if (this.props.TOReducer?.BinErr) {
            message.error(this.props.TOReducer?.BinErr);
            this.setState({
              binOptions: [],
            });
          } else {
            let values = [];

            this.props.TOReducer?.BinData?.map((k) =>
              values.push({
                value: k,
                label: k,
              })
            );

            if (values?.length) {
              if (isScan) {
                localStorage.setItem("selectedBin", e);
                this.setState({ selected: null, binOptions: [] });
                if (this.props.redirect === "to-putaway-item") {
                  this.props.onScanHandler("useScanner", e);
                } else {
                  this.props.onScanHandler(e);
                }
              }
            } else {
              message.error("No rack found");
            }

            this.setState({
              binOptions: values,
            });
          }
        });
    }
  };

  render() {
    let { openScanner } = this.state;
    return (
      <RackSearchWrapper>
        <Tabs
          defaultActiveKey="1"
          onChange={(e) => this.setState({ selectedTab: e })}
          items={[
            {
              label: `Rack Search`,
              key: "1",
              children: (
                <Select
                  ref={selectInputRef}
                  options={this.state.binOptions}
                  onInputChange={(e) => this.onChangeHandler(e)}
                  styles={customStyles}
                  isLoading={this.state.isLoading}
                  onChange={this.handleChange}
                  placeholder="Search Rack..."
                  value={this.state.selected}
                  isDisabled={this.props.disableSelect ?? false}
                />
              ),
            },
            {
              label: `Rack Scan`,
              key: "2",
              children: (
                <>
                  <button
                    className="scanBtn"
                    onClick={() => {
                      this.setState({ openScanner: true });
                    }}
                  >
                    Scan the Rack
                  </button>

                  {this.state.selectedRack && this.state.selectedRack == 2 ? (
                    <p>Selected Rack : {this.state.selectedRack}</p>
                  ) : null}
                </>
              ),
            },
          ]}
        />

        {openScanner ? (
          <BarcodeScanner
            scan={true}
            camera={true}
            redirect={this.props.redirect}
            confirmCall={this.onChangeHandler}
            getBoxId={() => this.setState({ openScanner: false })}
            closable
            isRackSearch
          />
        ) : null}
      </RackSearchWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

const mapDispatchToProps = { fetchBinThunk };

export default connect(mapStateToProps, mapDispatchToProps)(RackSearch);
